/* unplugin-vue-components disabled */import script from "./LogOff.vue?vue&type=script&setup=true&lang=js"
export * from "./LogOff.vue?vue&type=script&setup=true&lang=js"

import "./LogOff.vue?vue&type=style&index=0&id=6a40e32f&lang=less&scoped=true"

import exportComponent from "/Users/kummy/Documents/xsyx/grape-setting/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a40e32f"]])

export default __exports__